<template>
  <ul class="dropdown-menu">
    <slot></slot>
  </ul>
</template>
<script>
export default {
  name: "bc-dropdown-option-slot",
  render() {
    return this.$slots.default;
  },
};
</script>